/* tslint:disable */
import {InjectionToken} from '@angular/core';
export const API_HOST = new InjectionToken('API HOST');
